'use client';

import { useEffect } from 'react';

interface UseCloseListboxOnOutsideClickProps {
  isOpen: boolean;
  triggerRef?: React.RefObject<Element | null>;
  popoverRef?: React.RefObject<Element | null>;
  onClose: () => void;
  enabled?: boolean;
}

export const useCloseListboxOnOutsideClick = ({
  isOpen,
  triggerRef,
  popoverRef,
  onClose,
  enabled = true
}: UseCloseListboxOnOutsideClickProps) => {
  useEffect(() => {
    if (!enabled || !isOpen) return;

    const onPointerDown = (event: PointerEvent) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      if (triggerRef?.current?.contains(target)) return;
      if (popoverRef?.current?.contains(target)) return;
      onClose();
    };

    document.addEventListener('pointerdown', onPointerDown, true);
    return () => document.removeEventListener('pointerdown', onPointerDown, true);
  }, [enabled, isOpen, onClose, popoverRef, triggerRef]);
};
